import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import Home from './pages/Home'
import Navigation from "./components/Navigation";
import Anmeldung from "./pages/Anmeldung";
import CurrentTournament from "./pages/CurrentTournament";
import Winner from "./pages/Winner";
import Organizers from "./pages/Organizers";
import Archiv from "./pages/Archiv";
import Galerie from "./pages/Galerie";
import useFetch from "./hooks/useFetch";
import React from "react";


function App() {

    const { data: archives, loading: loadingArchives, error: errorArchives } = useFetch('https://steadfast-festival-dd089030c4.strapiapp.com/api/archivs?populate=*', {
        headers: {
            'Authorization': `Bearer ${process.env.REACT_APP_API_KEY}`,
            'Content-Type': 'application/json'
        }

    })
    const { data: galleries, loading: loadingGalleries, error: errorGalleries } = useFetch('https://steadfast-festival-dd089030c4.strapiapp.com/api/galleries?populate=*', {
        headers: {
            'Authorization': `Bearer ${process.env.REACT_APP_API_KEY}`,
            'Content-Type': 'application/json'
        }

    })



    if (loadingArchives || loadingGalleries) return <p>loading...</p>
    if (errorArchives || errorGalleries) return <p>Error :(</p>

  return (
      <Router>
        <div className="App">
          <Navigation />
              <Routes>
                  <Route exact path="/" element={<Home/>}/>
                  <Route path="/anmeldung" element={<Anmeldung/>}/>
                  <Route path="/räbejass" element={<CurrentTournament/>}/>
                  <Route path="/gewinner" element={<Winner/>}/>
                  <Route path="/organisatoren" element={<Organizers/>}/>
                  <Route path="/galerie" element={<Galerie/>}/>
                  {galleries.data.map(galerienavitem => (
                      <Route path={`/galerie/${galerienavitem.Title}`} element={<Galerie galerie_id={galerienavitem.documentId}/>}/>
                  ))}
                  {archives.data.map(archivnavitem => (
                      <Route path={`/archiv/${archivnavitem.Title}`} element={<Archiv archiv_id={archivnavitem.documentId}/>}/>
                  ))}

              </Routes>
        </div>
      </Router>
  );
}

export default App;
